/**
 * Onglet de catalogue effectivement ouvert.
 *
 * `requested` : `""` = pas encore choisi (le premier catalogue s'ouvre),
 * `null` = refermé par l'utilisateur (aucun onglet, ligne des notes repliée).
 * Un nom qui n'existe plus (changement de légende, filtre des catalogues)
 * retombe sur le premier catalogue ; un onglet refermé le reste, même quand la
 * liste des catalogues change.
 */
export function resolveActiveCatalogue(
  requested: string | null,
  names: string[],
): string | null {
  if (requested === null) return null;
  if (names.includes(requested)) return requested;
  return names[0] ?? null;
}

/**
 * Marge (px) avant de remonter les onglets sur la 1re ligne : sans elle, une
 * largeur à 1 px près ferait basculer l'en-tête à chaque redimensionnement.
 */
export const TABS_WRAP_HYSTERESIS_PX = 12;

/**
 * Les onglets de catalogue passent-ils sur la 2e ligne de l'en-tête ?
 *
 * @param naturalWidth largeur des onglets sans retour à la ligne (`null` =
 *   pas encore mesurée)
 * @param availableWidth place libre sur la 1re ligne, mesurée au même endroit
 *   que les onglets y soient ou non, sinon la décision oscillerait (`null` =
 *   pas encore mesurée). 0 veut dire « plus aucune place », pas « inconnue ».
 * @param wrapped décision actuelle
 */
export function shouldWrapCatalogueTabs(
  naturalWidth: number | null,
  availableWidth: number | null,
  wrapped: boolean,
  hysteresis: number = TABS_WRAP_HYSTERESIS_PX,
): boolean {
  if (naturalWidth === null || availableWidth === null || naturalWidth <= 0) {
    return wrapped;
  }
  if (!wrapped) return naturalWidth > availableWidth;
  return naturalWidth + hysteresis > availableWidth;
}
